import {
  EInvitationStatus,
  IInvitation,
  useAsyncEffect,
  useInviteClient,
} from '@jupiterone/jupiter-web-toolkit';
import React, { createContext, useContext, useState } from 'react';

const useInvitationLogic = () => {
  const { getAccountInvitations } = useInviteClient();
  const [invitations, setInvitations] = useState<IInvitation[]>([]);

  useAsyncEffect(async () => {
    const { items } = (await getAccountInvitations()) as {
      items: IInvitation[];
    };
    setInvitations(
      items.filter((i) => {
        i.status === EInvitationStatus.pending;
      })
    );
  }, []);

  const addInvitation = async (invitation: IInvitation) => {
    setInvitations((invitations) => [...invitations, invitation]);
  };

  const deletedInvitation = (invitation: IInvitation) => {
    setInvitations((invitations) =>
      invitations.filter(({ id }) => id !== invitation.id)
    );
  };

  return {
    invitations,
    deletedInvitation,
    addInvitation,
  };
};

type UseInvitation = ReturnType<typeof useInvitationLogic>;
const InvitationContext = createContext({} as UseInvitation);
const useInvitation = () => useContext(InvitationContext);
export default useInvitation;

interface UseInvitationContextProviderProps {
  children: React.ReactNode;
}

export const InvitationProvider = ({
  children,
}: UseInvitationContextProviderProps) => {
  const invitations = useInvitationLogic();
  return (
    <InvitationContext.Provider value={invitations}>
      {children}
    </InvitationContext.Provider>
  );
};
